import PropTypes from 'prop-types'
import React from 'react'
import { getFormattedAdPrice } from 'SRC/utils'

const renderPriceRange = (priceFrom, priceTo) => {
  if (priceFrom && priceTo) {
    return <div className='cena' key='priceRange'>
      <p>{getFormattedAdPrice(priceFrom)} do {getFormattedAdPrice(priceTo)} &euro;</p>
    </div>
  } else if (priceFrom && !priceTo) {
    return <div className='cena' key='priceFrom'>
      <p>Već od {getFormattedAdPrice(priceFrom)} &euro;</p>
    </div>
  } else if (!priceFrom && priceTo) {
    return <div className='cena' key='priceTo'>
      <p>Do {getFormattedAdPrice(priceTo)} &euro;</p>
    </div>
  } else {
    return null
  }
}

const renderRentPrice = (priceDaily, priceMonthly) => {
  return <React.Fragment>
    {priceMonthly ? <div className='cena'>
      <p>{getFormattedAdPrice(priceMonthly)} &euro; mjesec</p>
    </div> : null}
    {priceDaily ? <div className='cena' style={{ marginLeft: 15 }}>
      <p>{getFormattedAdPrice(priceDaily)} &euro; dan</p>
    </div> : null}
  </React.Fragment>
}

const renderRegularPrice = (newPrice, oldPrice, isBuying) => {
  if (!newPrice) return <div className='cena'><p>Po dogovoru</p></div> 

  return (
    <React.Fragment>
      <div className='cena'>
        <p>{`${isBuying ? 'do ' : ''}${getFormattedAdPrice(newPrice)}`}&euro;</p>
      </div>
      {oldPrice ? (
        <div className='stara-cena'>
          <span className={'stara-cena'}>{getFormattedAdPrice(oldPrice)}&euro;</span>
        </div>
      ) : null}
    </React.Fragment>
  )
}

export const Price = ({
  price,
  discount,
  priceType,
  priceFrom,
  priceTo,
  priceOnRequest,
  priceDaily,
  priceMonthly,
  priceSpecification,
  isBuying
}) => {
  if (priceSpecification === 0) return null

  if (typeof priceSpecification === 'object' && priceSpecification !== null && typeof priceSpecification.value !== 'undefined') {
    return (
      <div>
        <div className='cena'>
          <p>{`${priceSpecification.value} ${priceSpecification.measure || ''}`}</p>
        </div>
      </div>
    )
  }

  return (
    <div className={priceDaily || priceMonthly ? 'oglasi-headline-price-rent' : ''}>
      {!priceOnRequest
        ? <React.Fragment>
          {priceFrom || priceTo
            ? renderPriceRange(priceFrom, priceTo)
            : priceDaily || priceMonthly ? renderRentPrice(priceDaily, priceMonthly)
              : renderRegularPrice(price, discount, isBuying)
          }
        </React.Fragment> : <div className='cena'>
          <p>Cijena na upit</p>
        </div>
      }
      {
        priceType && !priceOnRequest
          ? <div className='vrsta-cene'>
            <p>{priceType}</p>
          </div>
          : null
      }
    </div>
  )
}

Price.propTypes = {
  priceSpecification: PropTypes.shape({
    value: PropTypes.string,
    measure: PropTypes.string
  }),
  discount: PropTypes.number,
  price: PropTypes.number.isRequired,
  priceFrom: PropTypes.number,
  priceTo: PropTypes.number,
  priceType: PropTypes.string,
  priceOnRequest: PropTypes.bool,
  priceDaily: PropTypes.number,
  priceMonthly: PropTypes.number,
  isBuying: PropTypes.bool
}
